<template>
  <router-link class="all-sequences-row-outer" :to="getGuideLink(sequence.id, $route.params.aid)">
    <div class="bg-white-1 border-beige-10 rounded-sm border border-solid">
      <div class="all-sequences-row" height="auto">
        <div class="all-sequences-thumb">
          <RfPromotionThumbnail v-if="sequence.paths.length" :item="sequence.paths[0]" />
          <div class="all-sequences-thumb-counter">
            {{ sequence.paths.length }}
          </div>
        </div>
        <div class="all-sequences-info">
          <div class="all-sequences-name flex pr-4">
            <h2 class="flex-1">
              {{ truncate(sequence.name, 30) }}
            </h2>
            <div class="flex h-8 flex-0 items-center gap-2">
              <RfSegmentBucketRange
                class="inline-flex items-center gap-1 text-blue-50"
                :showWarning="sequence.segments.length > 1"
                :bucketRange="bucketRange"
              />
              <v-tooltip location="bottom">
                <template #activator="{ props }">
                  <span v-bind="props" class="inline-flex" @click.stop.prevent>
                    <v-btn
                      variant="flat"
                      size="small"
                      :disabled="!!disableAssignTraffic"
                      :aria-label="disableAssignTraffic || 'Assign traffic'"
                      @click.stop.prevent="
                        () => !disableAssignTraffic && openAssignTrafficModal(sequence)
                      "
                    >
                      <v-icon size="16"> fa:fas fa-random </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ disableAssignTraffic || "Assign traffic" }}</span>
              </v-tooltip>
            </div>
          </div>
          <div :class="gridView ? 'all-sequences-details-grid' : 'all-sequences-details'">
            <div>
              <div class="field-name">Show Prompts</div>
              <div class="field">{{ displaySequenceType }}</div>
            </div>
            <div>
              <div class="field-name">Segments</div>
              <div class="field">
                <div v-for="(segment, index) in sequence.segments" :key="index">
                  <RouterLink
                    class="field-segment"
                    :to="getSegmentLink(segment.id, $route.params.aid)"
                  >
                    {{ segment.name }}
                  </RouterLink>
                </div>
                <div v-if="sequence.segments === undefined || sequence.segments.length === 0">
                  None
                </div>
              </div>
            </div>
            <div>
              <div class="field-name">Schedule</div>
              <div class="field">
                <span> Starts on {{ dateDisplay(sequence.start_date, { alter: true }) }} </span>
                <span> Ends on {{ dateDisplay(sequence.end_date, { alter: true }) || "∞" }} </span>
              </div>
            </div>
            <div>
              <div class="field-name">Status</div>
              <div class="field"><RfPromoPublishStatus :item="sequence" /></div>
            </div>
          </div>
        </div>
        <div class="all-sequences-metrics">
          <RfPlacementsStats
            :model="sequence.paths"
            :metricsKey="currChartSrc"
            :autoHeight="true"
            :class="
              gridView
                ? 'rf-metrics-arrow-responsive rf-metrics-grid'
                : 'rf-metrics-arrow-responsive'
            "
          />
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import RfPromoPublishStatus from "@/components/RfPromotions/RfPromoPublishStatus.vue";
import RfPlacementsStats from "@/components/RfPlacements/RfPlacementsStats.vue";
import RfPromotionThumbnail from "@/components/RfPromotions/RfPromotionThumbnail.vue";
import RfSegmentBucketRange from "@/components/RfSegments/RfSegmentBucketRange.vue";
import StringUtils from "@/utils/StringUtils";
import { GUIDE_TYPES } from "@/utils/constants/GuidesConstants";
import { dateDisplay } from "@/utils/DateDisplayUtils";
import { getGuideLink, getSegmentLink } from "@/utils/getLink";
import { RouterLink } from "vue-router";

export default {
  name: "RfSequencesListView",
  components: {
    RfPromoPublishStatus,
    RfPlacementsStats,
    RfPromotionThumbnail,
    RouterLink,
    RfSegmentBucketRange,
  },
  props: [
    "gridView",
    "sequence",
    "currChartSrc",
    "openAssignTrafficModal",
    "disableAssignTraffic",
    "bucketRange",
  ],
  setup: () => ({ truncate: StringUtils.truncate, dateDisplay, getSegmentLink, getGuideLink }),
  computed: {
    displaySequenceType() {
      return GUIDE_TYPES[this.sequence.sequence_type]?.label || GUIDE_TYPES.survey.label;
    },
  },
};
</script>

<style scoped lang="scss">
.field-segment {
  display: inline-block;
  border-radius: 5px;
  padding: 0 5px;
  margin-left: -5px;

  &:hover {
    background-color: #eee;
  }
}
</style>
